import axios from 'axios';

interface UploadParams {
  asset: string;
  fileType: string;
  themeId?: string;
}

export const uploadBase64ToS3 = async ({
  asset,
  fileType,
  themeId,
}: UploadParams): Promise<string> => {
  const token = document.querySelector('meta[name="csrf-token"]');
  const headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Authorization': window.validationToken,
    'X-CSRF-Token': token ? token.getAttribute('content') : '',
  };

  try {
    const res = await axios.post<{ key: string }>(
      '/upload_base64_to_s3',
      {
        base64_data: asset,
        file_type: fileType,
        theme_id: themeId,
      },
      { headers },
    );

    return res.data.key;
  } catch (error: any) {
    throw new Error(`Error while uploading file: ${error}`);
  }
};
